<script lang="ts">
    import type { Dialog, DialogButton } from "./dialog";
    import { onMount } from "svelte";
    import { getEntries } from "..";
    import Field from "./Field.svelte";

    let dialogElem: HTMLDialogElement;

    export let dialog: Dialog;

    onMount(() => {
        dialogElem.showModal();
    });

    let done = false;

    function close(reason: string = "close") {
        if (done) return;
        done = true;

        dialogElem.close();
        dialog.reject("close");
    }

    function confirm() {
        if (done) return;
        done = true;

        dialogElem.close();
        const result = getEntries(dialog.fields ?? {}).reduceRight((acc, [key, field]) => {
            if (field.type !== "text") {
                acc[key] = field.value;
            }
            return acc;
        }, {} as Record<string, any>);

        dialog.resolve(result);
    }

    function onKeyDown(e: KeyboardEvent) {
        if (e.key === "Enter") {
            confirm();
        }
    }
</script>

<!----------------------------------------------------------------------------->

<dialog bind:this={dialogElem} on:close={() => close("close")} on:keydown={onKeyDown}>
    <h2>{dialog.title}</h2>
    {#if dialog.content}
        <p>{dialog.content}</p>
    {/if}

    {#if dialog.fields}
        {#each Object.values(dialog.fields) as field}
            <Field {field} />
        {/each}
    {/if}

    <div class="buttons">
        {#each dialog.buttons as btn}
            <button on:click={() => btn.action(confirm, close)}>{btn.label}</button>
        {/each}
    </div>
</dialog>

<!----------------------------------------------------------------------------->

<style>
    dialog {
        display: grid;
        grid-template-columns: max-content 1fr;
        grid-auto-rows: max-content;
        row-gap: 0.5rem;

        padding: 1rem;

        border: 2px solid var(--gap-color-hard);
        background: var(--g100);
        min-width: 32ch;
    }

    dialog::backdrop {
        background-color: #0006;
    }

    h2 {
        grid-column: span 2;

        margin: 0;
        color: var(--t400);
        font-size: 1.5rem;
        font-weight: normal;
    }

    p {
        grid-column: span 2;

        margin: 0;
    }

    .buttons {
        grid-column: span 2;

        display: flex;
        justify-self: right;
        gap: 0.5rem;
        margin-top: 1rem;
    }
</style>
